import React from 'react'
import {useSpring, animated} from 'react-spring/web.cjs'
import {Box, Grid, Hidden} from '@material-ui/core'

const calc = (x: number, y: number) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const c = (x: any | undefined) => `${90 - Math.round(x) / 100}% center`
const b = (x: any | undefined) => `translateX(${x / 30}px`

const Four = () => {
  const [propsSpring, set] = useSpring(() => ({xy: [0, 0], config: {mass: 1, tension: 400, friction: 50}}))

  return (
    <Grid container justify={'space-between'} alignItems={'center'} onMouseMove={({clientX: x, clientY: y}) => set({xy: calc(x, y)})}>
      <Box className={'parallax_container'}>
        <Hidden smDown>
          <animated.img className={'four_b1'} src={`/img/page4/b1.png`} style={{transform: propsSpring.xy.interpolate(b)}} />
          <img className={'four_b2'} src={`/img/page4/b-other.png`} alt={''} />
        </Hidden>
        <Hidden mdUp>
          <img className={'four_b1'} src={`/img/page4/b1.png`} alt={''} />
          <img className={'four_b2'} src={`/img/page4/b-other.png`} alt={''} />
        </Hidden>
      </Box>

      <Grid item xs={12} md={6} style={{height: '90%'}}>
        <Grid container className={'paper'} justify={'flex-start'} alignItems={'flex-start'} style={{height: '100%'}}>
          <Grid item xs={12} className={'paper-list_item'}>
            <span>TTL CAMPAIGN</span>
          </Grid>
          <Grid item xs={12} className={'paper-list_item'}>
            <span>CONSUMER & TRADE PROMOTION</span>
            Федеральные и локальные NCP / B2B программы лояльности
          </Grid>
          <Grid item xs={12} className={'paper-list_item'}>
            <span>DIGITAL & SMM</span>
            Медийная и таргетированная реклама/ Programmatic / Ведение и развитие сообществ / Influence marketing
          </Grid>
          <Grid item xs={12} className={'paper-list_item'}>
            <span>STRATEGY & ANALYTICS</span>
            Стратегия продвижения / Планирование / Расчет KPI / Аналитика
          </Grid>
          <Grid item xs={12} className={'paper-list_item'}>
            <span>CREATIVE</span>
            Креативные концепции / 3D и графический дизайн / Cоздание контента
          </Grid>
          <Grid item xs={12} className={'paper-list_item'}>
            <span>EVENTS</span>
            Off-line / On-line / Гибридные B2B и B2C мероприятия
          </Grid>
        </Grid>
      </Grid>

      <Hidden smDown>
        <Grid item xs={11} md={6} style={{height: '90%'}}>
          <animated.div className={'c'} style={{backgroundPosition: propsSpring.xy.interpolate(c)}} />
        </Grid>
      </Hidden>
    </Grid>
  )
}

export default Four
